import { themeGet } from '@pocketlaw/tetris';
import { css } from 'styled-components';
export const highlightStyles = css `
  .pl-highlight--assistant {
    background-color: ${themeGet('colors.magenta.100')};
  }
`;
